<template>
  <div class="title">
    App Details
  </div>
  <div class="body">
    <div class="about-line">
      <span class="about-label">Version:</span> {{ bundleVersion }}
    </div>
    <div v-if="isNative" class="about-line">
      <span class="about-label">{{ platformName }} app:</span> {{ appVersion }} ({{ appBuild }})
    </div>
  </div>
  <div class="footer">
    <button
      class="dg primary"
      @click="close"
    >
      Close
    </button>
  </div>
</template>

<script>
  // Shown on web and in the native apps. "App version" and the platform
  // build only exist inside the iOS/Android shell (App.getInfo is native-
  // only) so those two rows are hidden on web; "RH client build" is the
  // stamp of the JS bundle actually running everywhere — it diverges from
  // the store build once over-the-air bundle updates are live, which is
  // exactly when support needs both.
  import { mapActions } from "vuex"
  import { Capacitor } from "@capacitor/core"
  import { App } from "@capacitor/app"
  import { RH_CLIENT_BUILD } from "@/common/constants"

  export default {
    data() {
      return {
        appVersion: "…",
        appBuild: "…",
      }
    },
    computed: {
      isNative() {
        const p = Capacitor.getPlatform()
        return p === "ios" || p === "android"
      },
      bundleVersion() {
        return String(RH_CLIENT_BUILD())
      },
      platformName() {
        const p = Capacitor.getPlatform()
        return p === "ios" ? "iOS" : p === "android" ? "Android" : p
      },
    },
    async mounted() {
      if (!this.isNative) { return }
      try {
        // version = CFBundleShortVersionString / versionName (e.g. 8.6.81)
        // build   = CFBundleVersion / versionCode — the number the stores and
        //           OTA's requires_native_build gate actually key on
        const info = await App.getInfo()
        this.appVersion = info.version || "unknown"
        this.appBuild = info.build || "unknown"
      } catch (e) {
        // App.getInfo is native-only; on web (or an old shell) just say so.
        this.appVersion = "unavailable"
        this.appBuild = "unavailable"
      }
    },
    methods: {
      ...mapActions("user", ["setModalProps"]),
      close() {
        this.setModalProps({})
      },
    },
  }
</script>

<style scoped>
  .about-line {
    font-size: 16px;
    padding: 6px 0;
    user-select: text;
    -webkit-user-select: text;
  }

  .about-label {
    font-weight: bold;
  }
</style>
